/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import NewsApi from "~/features/news/NewsApi";

export const getActiveNewsAsync = createAsyncThunk("news/getActiveNews", async () => {
  const response = await NewsApi.getActiveNews();

  return response.data.result;
});
